import React from 'react';
import { CheckIcon, SparkleIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const frictionPoints = ['No more hours searching for your next class idea.', 'No more disconnected routines.', 'No more repeating the same hip and hamstring sequence because planning time ran out.', 'No more wondering what progression should come next.', 'No more beginning every week from an empty page.'];
const included = ['6 Complete Instructor Volumes', '150 Ready-to-Teach Stretching Classes', '100% Visual Core Teaching Material', 'Stretching Foundations', 'Lower-Body Flexibility', 'Upper-Body Flexibility', 'Dynamic Stretching', 'Active Mobility', 'Full-Body Stretching', 'Recovery', 'Progressive Programming', 'Class Structures', 'Coaching Cues', 'Corrections', 'Modifications', 'Progressions', '5 Professional Bonus Guides', 'Immediate Digital Access', 'PDF Format'];
export function FinalCTA() {
  return <section className="bg-inverse px-4 py-20 text-inverse-foreground sm:py-28" data-id="element-118" data-mp="2h37wsvy0ggy1">
      <div className="mx-auto max-w-4xl" data-id="element-119" data-mp="2m2u9n49xfv6b">
        <div className="text-center" data-id="element-120" data-mp="2m1sw8t5fuwlf">
          <h2 className="text-3xl font-semibold leading-tight text-inverse-foreground sm:text-4xl" data-id="element-121" data-mp="2m4xbclkfzcqv">
            Next Week You Can Keep Planning Every Stretching Class From
            Scratch…
            <br data-id="element-122" data-mp="2v1g1xr57aoka" />
            <span className="italic text-accent-soft" data-id="element-123" data-mp="302lv1q2rwduc">
              Or you can open a complete system and already know where to
              start.
            </span>
          </h2>
          <Ornament className="mt-6" data-id="element-124" data-mp="34vez0bqf3i5d" />
          <div className="mx-auto mt-10 max-w-2xl rounded-xl border border-inverse-foreground/10 bg-inverse-foreground/[0.04] p-7 text-left" data-id="element-125" data-mp="39sybb63k1kuo">
            <ul className="space-y-3" data-id="element-126" data-mp="3et2syzg78lmh">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-inverse-foreground/80" data-id="element-127" data-mp="3itwgvstn60fd">
                  <SparkleIcon size={16} className="mt-1 shrink-0 text-accent" aria-hidden="true" data-id="element-128" data-mp="1epiiplz11th6" />
                  {point}
                </li>)}
            </ul>
          </div>
          <p className="mx-auto mt-10 max-w-3xl font-display text-3xl font-semibold text-accent-soft" data-id="element-129" data-mp="1nnu5te0oq94v">
            Stretching Instructor Ready does not replace your knowledge as an
            instructor.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-inverse-foreground/70" data-id="element-130" data-mp="2bfj02zx2h7og">
            It gives you a system for using that knowledge with greater
            structure, variety and efficiency.
          </p>
        </div>

        <div className="mt-14 rounded-2xl border border-accent/50 bg-inverse-raised p-7 shadow-elevated sm:p-11" data-id="element-131" data-mp="h29pt5wp5i55">
          <h3 className="text-center text-3xl font-semibold text-inverse-foreground" data-id="element-132" data-mp="d1hgkcntrd8v">
            Everything Included
          </h3>
          <Ornament className="mt-4" data-id="element-133" data-mp="6xjv9l3mhgay" />
          <ul className="mt-8 grid gap-x-8 md:grid-cols-2" data-id="element-134" data-mp="6wi6yexlixba">
            {included.map(item => <li key={item} className="flex items-baseline gap-3 border-b border-accent/15 py-3" data-id="element-135" data-mp="3pahq5dlk5iy9">
                <CheckIcon size={15} className="shrink-0 translate-y-0.5 text-accent" aria-hidden="true" data-id="element-136" data-mp="3u8atzzze20vd" />
                <span className="text-sm font-medium leading-6 text-inverse-foreground/90" data-id="element-137" data-mp="3ke0y48b8mkfw">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xs font-medium uppercase tracking-[0.1em] text-inverse-foreground/60" data-id="element-138" data-mp="3bckqu9fpyyfw">
            Immediate Access · Complete Digital PDF Bundle
          </p>

          <div className="mt-10 rounded-xl border border-accent/40 bg-primary-strong px-6 py-9 text-center" data-id="element-139" data-mp="19jd9kugjq6rd">
            <p className="font-display text-3xl font-semibold text-primary-foreground" data-id="element-140" data-mp="35m88ofv523sj">
              <ProductName script accentClassName="text-accent-soft" data-id="element-141" data-mp="30phtrvv2le8p" />
            </p>
            <p className="mx-auto mt-4 max-w-xl font-display text-xl italic leading-8 text-primary-foreground" data-id="element-142" data-mp="2volszr60m87i">
              The Complete 6-in-1 Visual Teaching System for Stretching
              Instructors
            </p>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-primary-foreground/80" data-id="element-143" data-mp="2mq9ul2ywq64i">
              150 Ready-to-Teach Classes • 6 Complete Volumes • 100% Visual
              Core Material • 5 Professional Bonus Guides
            </p>
            <p className="mt-5 text-xs font-bold tracking-[0.2em] text-accent-soft" data-id="element-144" data-mp="27zsr7e2pp64z">
              SEE IT. CHOOSE IT. TEACH IT.
            </p>
          </div>

          <div className="mt-10 flex flex-col items-center text-center" data-id="element-145" data-mp="23xeb31qfgkhe">
            <PriceTag tone="dark" data-id="element-146" data-mp="1z05sx15a4gg5" />
            <CheckoutButton variant="inverse" className="mt-7" data-id="element-147" data-mp="1z17ehzjx8lc4">
              GET STRETCHING INSTRUCTOR READY NOW
            </CheckoutButton>
            <p className="mt-5 text-xs text-inverse-foreground/60" data-id="element-148" data-mp="jfn9goqo7gt7">
              Immediate Access · Complete Digital PDF Bundle
            </p>
          </div>
        </div>
      </div>
    </section>;
}